export default "<app-loading></app-loading>\n<router-outlet></router-outlet>";